import React from 'react';
import { FieldValidator, useField } from 'formik';
import DaysOfWeekInput from 'components/form-fields/DayOfWeek';

interface Props {
  name: string;
  validate?: FieldValidator;
  disabled?: boolean;
}

const DaysOfWeekField: React.FC<Props> = ({
  name,
  validate,
  disabled = false,
}) => {
  const [field, meta, helpers] = useField<string[]>({ name, validate });
  return (
    <DaysOfWeekInput
      value={field.value?.map((v) => v.toLowerCase())}
      disabled={disabled}
      onChange={(value: string[]) => {
        helpers.setValue(
          value?.map((v) => v.toUpperCase()),
          true
        );
      }}
    />
  );
};

export default DaysOfWeekField;
